import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {
  NEWS_DETAILS_GET,
  NEWS_DETAILS_RESET,
  NEWS_LIST_GET,
} from '../actions/news';

const initialState = {
  filters: {},
  list: [],
  details: {},
  pager: {},
};

const userReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case NEWS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.filters = { ...state.filters, ...(response?.filters || {}) };
        draft.list = response?.items || [];
        draft.pager = response?.pager ?? {};
        break;
      }

      case NEWS_DETAILS_GET._SUCCESS: {
        const { response = {} } = action;
        draft.details = { ...response };
        break;
      }

      case NEWS_DETAILS_RESET: {
        draft.details = initialState.details;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default userReducer;
